import { Component, OnInit } from '@angular/core';
import { Usuario } from '../../model/usuario';
import { IngresoService } from '../../services/ingreso.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { RouterModule, Routes, Router } from '@angular/router';
@Component({
  selector: 'app-ingreso',
  templateUrl: './ingreso.component.html',
  styleUrls: ['./ingreso.component.css']
})
export class IngresoComponent implements OnInit {

  public usuario: Usuario = new Usuario();

  constructor(
    private _IngresoService: IngresoService,
    private _localStorageService: LocalStorageService,
    private _router: Router
  ) { }

  ngOnInit() {
    var div = document.getElementById("Menu_Nav");
    if (div) {
      div.style.display = "none";
    }
  }

  onSubmit() {
    this._IngresoService.find(this.usuario).subscribe(
      data => {
        this.Check_Login(data);
      },
      err => {
        console.clear();
        console.log(err);
      });
  }

  Check_Login(data: any) {
    if (data.Resultado === false) {
      alert("Correo o Contraseña no son correctos");
      this.usuario.email = "";
      this.usuario.clave = "";
    } else {
      sessionStorage.setItem("login", this.usuario.email);
      ///location.href = 'inicio';    
      this._router.navigate(['inicio'])  ;
    }
  }

}


// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/ingreso/ingreso.component.ts